var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"info","depressed":_vm.isVerified,"disabled":_vm.isVerified,"outlined":!_vm.isVerified},on:{"click":function($event){_vm.isVerified = true}}},[_c('div',{staticClass:"px-5",domProps:{"textContent":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }